import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Dialog,
  Fade,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

export default function SaleProductDeleteDialog({
  open,
  product,
  deleting,
  error,
  onClose,
  onConfirm,
}) {
  function handleClose() {
    if (!deleting) onClose?.();
  }

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      maxWidth={false}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          borderRadius: "30px",
          overflow: "visible",
          m: 1.5,
        },
      }}
      slotProps={{
        backdrop: {
          timeout: 180,
          sx: {
            bgcolor: "rgba(2, 8, 23, 0.45)",
            backdropFilter: "blur(3px)",
          },
        },
      }}
    >
      <Fade in={Boolean(open)} timeout={180}>
        <Box
          sx={{
            width: "min(92vw, 460px)",
            bgcolor: "neutral.300",
            borderRadius: "30px",
            p: { xs: 2.2, sm: 2.7 },
            boxShadow: "0px 20px 60px rgba(0,0,0,.28)",
          }}
        >
          <Stack spacing={2}>
            <Stack
              direction="row"
              sx={{ alignItems: "center", justifyContent: "space-between" }}
            >
              <Typography sx={{ fontSize: 20, fontWeight: 800, color: "primary.900" }}>
                Eliminar producto
              </Typography>
              <IconButton
                type="button"
                size="small"
                disabled={deleting}
                onClick={handleClose}
                aria-label="Cerrar confirmación de eliminación"
              >
                <CloseIcon sx={{ color: "primary.900" }} />
              </IconButton>
            </Stack>

            <Box
              sx={{
                p: 2,
                borderRadius: "20px",
                bgcolor: "neutral.50",
                boxShadow: "inset 0px 0px 3px rgba(142,142,159,.35)",
              }}
            >
              <Typography sx={{ fontSize: 13, fontWeight: 700, color: "primary.900" }}>
                ¿Querés eliminar <strong>{product?.name}</strong>?
              </Typography>
              <Typography sx={{ mt: 0.7, fontSize: 11.5, color: "neutral.700" }}>
                El producto dejará de aparecer en el listado.
              </Typography>
            </Box>

            {error ? <Alert severity="error">{error}</Alert> : null}

            <Stack direction="row" spacing={1.2} sx={{ justifyContent: "flex-end" }}>
              <Button
                type="button"
                disabled={deleting}
                onClick={handleClose}
                sx={{ borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
              >
                Cancelar
              </Button>
              <Button
                type="button"
                variant="contained"
                color="error"
                disabled={deleting}
                onClick={onConfirm}
                startIcon={
                  deleting ? (
                    <CircularProgress size={15} color="inherit" />
                  ) : (
                    <DeleteOutlineIcon sx={{ fontSize: 18 }} />
                  )
                }
                sx={{ minWidth: 120, borderRadius: "20px", textTransform: "none", fontWeight: 800 }}
              >
                {deleting ? "Eliminando..." : "Eliminar"}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Dialog>
  );
}
